AUDIO = new Audio('sounds/new.mp3')
ANIMATION_DURATION = 300

App.SmNotificationComponent = Em.Component.extend
  notifier: Em.inject.service()

  classNames: ['sm-notification']
  classNameBindings: [ 'isOpaque' ]

  message: Em.computed.alias('content.message')
  title:   Em.computed.alias('content.title')

  backgroundImage: (->
    if @get('content.imageUrl')? and @get('content.type') == 'image'
      new Ember.Handlebars.SafeString("background-image: url(#{@get('content.imageUrl')})")
  ).property('content.imageUrl')

  iconType: (->
    'icon-' + @get('content.type')
  ).property('content.type')

  attributeBindings: ['style']

  click: (e) ->
    if $( e.target ).is('.sm-close')
    else
      @send('primaryAction')

  init: ->
    @_super()
    onWindowResize = (-> @notifyPropertyChange('style')).bind(@)
    @set('_onWindowResize', onWindowResize)
    Em.$(window).bind('resize', onWindowResize)

    if localStorage.getItem('soundNotificationsVerbose') == 'true'
      AUDIO.play() 


  willDestroyElement: ->
    Em.$(window).unbind('resize', @get('_onWindowResize'))

    $parent = @$().closest('.sm-notification-container')
    $ghost =  @$().clone()
    $parent.append $ghost

    Em.run.later =>
      $ghost.removeClass('is-opaque')

      Em.run.later =>
        $ghost.remove()
      , ANIMATION_DURATION

  didInsertElement: ->
    # Анимация появления
    Ember.run.next =>
      return if @get('isDestroyed')
      @set('isOpaque', true)

    @notifyPropertyChange('style')

  # Используется для анимации
  isOpaque: false

  style: (->
    notifications = @get('notifier.limitedQueue')
    index = notifications.indexOf(@get('content'))

    $bar = Em.$('header.navigation-bar')

    outerShift = if $bar.length
      $bar.position().top + $bar.outerHeight()
    else
      0

    viewportHeight = Em.$(window).height() - outerShift

    unitHeight = 85
    unitWidth = 330
    unitsPerColumn = Math.floor(viewportHeight / unitHeight)
    column = Math.floor(index / unitsPerColumn)
    row = index % unitsPerColumn

    return ''.htmlSafe() if index == -1

    topPx   = outerShift + row * unitHeight
    bottomPx   = row * unitHeight
    rightPx = column * unitWidth

    hasPendingElements = @get 'notifier.limitedQueue.hasPendingElements'

    if hasPendingElements and column == 0
        bottomPx += 60

    "bottom: #{bottomPx}px; right: #{rightPx}px;".htmlSafe()
  ).property('notifier.limitedQueue.[]', 'notifier.limitedQueue.hasPendingElements')

  actions:
    primaryAction: ->
      @get('content.handler')?()
      @send('close')
      false

    close: ->
      @get('notifier.queue').removeObject( @get('content') )
